// extracted by mini-css-extract-plugin
export default {"text":"Activate_text__juFkB","button":"Activate_button__tO0ZU"};